// @ts-nocheck
import {Percent, CurrencyUSD, Time, GraphQLDecimal} from '@/graphql/scalars'

import * as Types from '../../../../types/schema';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type PresentationTemplateSelectionQueryVariables = Types.Exact<{
  currentUserId: Types.Scalars['ID']['input'];
  systemTemplateWhere: Types.PresentationTemplateWhereInput;
}>;


export type PresentationTemplateSelectionQuery = { __typename?: 'Query', userTemplates: { __typename?: 'PresentationTemplateConnection', edges?: Array<{ __typename?: 'PresentationTemplateEdge', node?: (
        { __typename?: 'PresentationTemplate' }
        & PresentationTemplateSelection_PresentationTemplateFragment
      ) | null } | null> | null }, tenantTemplates: { __typename?: 'PresentationTemplateConnection', edges?: Array<{ __typename?: 'PresentationTemplateEdge', node?: (
        { __typename?: 'PresentationTemplate' }
        & PresentationTemplateSelection_PresentationTemplateFragment
      ) | null } | null> | null }, luminaryTemplates: { __typename?: 'PresentationTemplateConnection', edges?: Array<{ __typename?: 'PresentationTemplateEdge', node?: (
        { __typename?: 'PresentationTemplate' }
        & PresentationTemplateSelection_PresentationTemplateFragment
      ) | null } | null> | null } };

export type StartCreatePresentationFromTemplateMutationVariables = Types.Exact<{
  templateID: Types.Scalars['ID']['input'];
  householdID: Types.Scalars['ID']['input'];
}>;


export type StartCreatePresentationFromTemplateMutation = { __typename?: 'Mutation', startCreatePresentationFromTemplate: { __typename?: 'StartCreatePresentationFromTemplatePayload', presentation: { __typename?: 'ClientPresentationV2', id: string } } };

export type PresentationTemplateSelection_PresentationTemplateFragment = { __typename?: 'PresentationTemplate', id: string, displayName: string, tenantID: string, luminaryOrganizationID?: string | null, systemTemplateKind?: Types.PresentationTemplateSystemTemplateKind | null, bundles: { __typename?: 'PresentationTemplateBundleConnection', edges?: Array<{ __typename?: 'PresentationTemplateBundleEdge', node?: { __typename?: 'PresentationTemplateBundle', id: string, kind: Types.PresentationBundleKind, index: number, documentSummaryTemplateBundleConfiguration?: { __typename?: 'DocumentSummaryTemplateBundleConfiguration', id: string, documentType?: Types.PresentationDocumentType | null, includeFirstGrantor: boolean, includeSecondGrantor: boolean } | null, pages: { __typename?: 'PresentationTemplatePageConnection', edges?: Array<{ __typename?: 'PresentationTemplatePageEdge', node?: { __typename?: 'PresentationTemplatePage', id: string, kind: Types.PresentationPageKind, customPage?: { __typename?: 'PresentationTemplateCustomPage', id: string, pageName: string } | null, diagramPage?: { __typename?: 'PresentationTemplateDiagramPage', id: string, pageName: string } | null } | null } | null> | null } } | null } | null> | null } };

export const Operations = {
  Query: {
    PresentationTemplateSelection: 'PresentationTemplateSelection' as const
  },
  Mutation: {
    StartCreatePresentationFromTemplate: 'StartCreatePresentationFromTemplate' as const
  },
  Fragment: {
    PresentationTemplateSelection_PresentationTemplate: 'PresentationTemplateSelection_PresentationTemplate' as const
  }
}

/**
 * Custom plugin to wrap useQuery hooks with automatic context.fetchPolicy injection
 */
function withFetchPolicyContext(options) {
  const fetchPolicy = options?.fetchPolicy ?? 'cache-first';
  const isLazy = options?.isLazy ?? undefined;
  return {
    ...options,
    context: {
      ...options?.context,
      fetchPolicy,
      isLazy,
    },
  };
}

/**
 * Defaults useSubscription to ignoreResults: true so Apollo skips its
 * per-message useSyncExternalStore notification (forceStoreRerender). All
 * call sites manage state via onData; opting out avoids render storms when
 * messages arrive in a synchronous burst. See T2-10011. Callers that need
 * Apollo to surface data/loading/error can override by passing
 * ignoreResults: false explicitly.
 */
function withSubscriptionIgnoreResults(options) {
  return {
    ignoreResults: true,
    ...options,
  };
}

export const PresentationTemplateSelection_PresentationTemplateFragmentDoc = gql`
    fragment PresentationTemplateSelection_PresentationTemplate on PresentationTemplate {
  id
  displayName
  tenantID
  luminaryOrganizationID
  systemTemplateKind
  bundles(orderBy: {field: index, direction: ASC}) {
    edges {
      node {
        id
        kind
        index
        documentSummaryTemplateBundleConfiguration {
          id
          documentType
          includeFirstGrantor
          includeSecondGrantor
        }
        pages {
          edges {
            node {
              id
              kind
              customPage {
                id
                pageName
              }
              diagramPage {
                id
                pageName
              }
            }
          }
        }
      }
    }
  }
}
    `;
export const PresentationTemplateSelectionDocument = gql`
    query PresentationTemplateSelection($currentUserId: ID!, $systemTemplateWhere: PresentationTemplateWhereInput!) {
  userTemplates: presentationTemplates(
    where: {and: [{type: USER_TEMPLATE}, {hasUserWith: [{id: $currentUserId}]}, {systemTemplateKindIsNil: true}]}
  ) {
    edges {
      node {
        ...PresentationTemplateSelection_PresentationTemplate
      }
    }
  }
  tenantTemplates: presentationTemplates(
    where: {and: [{type: TENANT_TEMPLATE}, {systemTemplateKindIsNil: true}]}
  ) {
    edges {
      node {
        ...PresentationTemplateSelection_PresentationTemplate
      }
    }
  }
  luminaryTemplates: presentationTemplates(
    where: {and: [{type: TENANT_TEMPLATE}, $systemTemplateWhere]}
  ) {
    edges {
      node {
        ...PresentationTemplateSelection_PresentationTemplate
      }
    }
  }
}
    ${PresentationTemplateSelection_PresentationTemplateFragmentDoc}`;

/**
 * __usePresentationTemplateSelectionQuery__
 *
 * To run a query within a React component, call `usePresentationTemplateSelectionQuery` and pass it any options that fit your needs.
 * When your component renders, `usePresentationTemplateSelectionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePresentationTemplateSelectionQuery({
 *   variables: {
 *      currentUserId: // value for 'currentUserId'
 *      systemTemplateWhere: // value for 'systemTemplateWhere'
 *   },
 * });
 */
export function usePresentationTemplateSelectionQuery(baseOptions: Apollo.QueryHookOptions<PresentationTemplateSelectionQuery, PresentationTemplateSelectionQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PresentationTemplateSelectionQuery, PresentationTemplateSelectionQueryVariables>(PresentationTemplateSelectionDocument, withFetchPolicyContext(options));
      }
export function usePresentationTemplateSelectionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PresentationTemplateSelectionQuery, PresentationTemplateSelectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PresentationTemplateSelectionQuery, PresentationTemplateSelectionQueryVariables>(PresentationTemplateSelectionDocument, withFetchPolicyContext({ ...options, isLazy: true }));
        }
export function usePresentationTemplateSelectionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PresentationTemplateSelectionQuery, PresentationTemplateSelectionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PresentationTemplateSelectionQuery, PresentationTemplateSelectionQueryVariables>(PresentationTemplateSelectionDocument, withFetchPolicyContext(options));
        }
export type PresentationTemplateSelectionQueryHookResult = ReturnType<typeof usePresentationTemplateSelectionQuery>;
export type PresentationTemplateSelectionLazyQueryHookResult = ReturnType<typeof usePresentationTemplateSelectionLazyQuery>;
export type PresentationTemplateSelectionSuspenseQueryHookResult = ReturnType<typeof usePresentationTemplateSelectionSuspenseQuery>;
export type PresentationTemplateSelectionQueryResult = Apollo.QueryResult<PresentationTemplateSelectionQuery, PresentationTemplateSelectionQueryVariables>;
export const StartCreatePresentationFromTemplateDocument = gql`
    mutation StartCreatePresentationFromTemplate($templateID: ID!, $householdID: ID!) {
  startCreatePresentationFromTemplate(
    templateID: $templateID
    householdID: $householdID
  ) {
    presentation {
      id
    }
  }
}
    `;
export type StartCreatePresentationFromTemplateMutationFn = Apollo.MutationFunction<StartCreatePresentationFromTemplateMutation, StartCreatePresentationFromTemplateMutationVariables>;

/**
 * __useStartCreatePresentationFromTemplateMutation__
 *
 * To run a mutation, you first call `useStartCreatePresentationFromTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartCreatePresentationFromTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startCreatePresentationFromTemplateMutation, { data, loading, error }] = useStartCreatePresentationFromTemplateMutation({
 *   variables: {
 *      templateID: // value for 'templateID'
 *      householdID: // value for 'householdID'
 *   },
 * });
 */
export function useStartCreatePresentationFromTemplateMutation(baseOptions?: Apollo.MutationHookOptions<StartCreatePresentationFromTemplateMutation, StartCreatePresentationFromTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartCreatePresentationFromTemplateMutation, StartCreatePresentationFromTemplateMutationVariables>(StartCreatePresentationFromTemplateDocument, options);
      }
export type StartCreatePresentationFromTemplateMutationHookResult = ReturnType<typeof useStartCreatePresentationFromTemplateMutation>;
export type StartCreatePresentationFromTemplateMutationResult = Apollo.MutationResult<StartCreatePresentationFromTemplateMutation>;
export type StartCreatePresentationFromTemplateMutationOptions = Apollo.BaseMutationOptions<StartCreatePresentationFromTemplateMutation, StartCreatePresentationFromTemplateMutationVariables>;